import { render } from "./contact.vue?vue&type=template&id=8a44d0b6&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"

import "./contact.vue?vue&type=style&index=0&id=8a44d0b6&scoped=true&lang=css"
import "./contact.vue?vue&type=style&index=1&id=8a44d0b6&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a44d0b6"]])

export default __exports__